import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import fr from 'facet-rest';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import useUserContext from 'Context/UserContext';
import { NotificationPreferenceOverride } from 'Overrides/NotificationPreferenceOverride';
import { useSnackbarContext } from 'Context/SnackbarContext';
import MessagesPreferencesLayout from './MessagesPreferencesLayout';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    width: '100%',
    marginTop: theme.spacing(2),
  },
});

const MessagesPreferences = ({
  className,
  classes,
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'MessagesPreferences',
    isPageView: true,
  });
  const [notificationPreference, setNotificationPreference] = useState();
  const { agentResource } = useUserContext();
  const { displaySuccess, displayErrorMessage } = useSnackbarContext();

  useEffect(() => {
    const fetch = async () => {
      const np = await agentResource.relationship(fr.relationships.notificationPreference.name).link('related').get();
      if (np.resources().list().length === 0) {
        np.create({ addToCollection: true });
      }
      setNotificationPreference(np);
    };
    if (agentResource) {
      fetch();
    }
  }, [agentResource?.id()]);

  return (
    <div
      className={classNames(classes.root, className)}
      test={'settings-preferences-messages-content'}
      {...rootNodeProps}
    >
      {notificationPreference && <MetaCollectionFormInline
        collection={notificationPreference}
        metaOverrideSet={NotificationPreferenceOverride}
        FormProps={{
          layout: MessagesPreferencesLayout,
          onSubmit: (res) => {
            displaySuccess('Notification Preferences Saved');
            return res;
          },
          onFailure: (err) => {
            displayErrorMessage(err.errors);
          },
          inlineSubmit: true,
        }}
      />}
    </div>
  );
};

MessagesPreferences.defaultProps = {
  className: '',
};

MessagesPreferences.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MessagesPreferences);
